// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NCyg","title":"styles_title__2yHc9"};